import fullScreenMenu from '../../plugins/fullscreenmenu.js';

fullScreenMenu.init({
  breakPoint: 768
});